import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { api } from "@/lib/api";

export default function MarketingUnsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const t = params.get("t");
    if (!t) { setState("error"); return; }
    api.post("/marketing/unsubscribe", { token: t }).then(() => setState("ok")).catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#F5F5F5" }}>
      <div className="vg-card p-8 max-w-md w-full" data-testid="unsubscribe-page">
        <div className="mb-6"><Logo size={22} /></div>
        {state === "loading" && <p className="text-gray-500">Aggiornamento in corso…</p>}
        {state === "ok" && (
          <div data-testid="unsubscribe-success">
            <h1 className="text-2xl font-bold text-[#0A0A0A] mb-2">Disiscrizione completata</h1>
            <p className="text-sm text-gray-600">Non riceverai più avvisi email sui materiali marketing. Puoi riattivarli quando vuoi dall'area «Marketing &amp; Lead».</p>
          </div>
        )}
        {state === "error" && (
          <div data-testid="unsubscribe-error">
            <h1 className="text-2xl font-bold text-[#0A0A0A] mb-2">Link non valido</h1>
            <p className="text-sm text-gray-600">Accedi alla tua area per gestire le preferenze email.</p>
          </div>
        )}
        <Link to="/login" className="inline-block mt-6 text-sm font-semibold text-[#B40101]" data-testid="unsubscribe-login-link">Vai all'accesso</Link>
      </div>
    </div>
  );
}
